module.exports = __webpack_public_path__ + "assets/images/close-modal-button.54e46fd96fff0195ac5f2c222bf401fb.svg";